<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-SuShe`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.81055 4.5V17.625M3.81055 17.625V19.125M3.81055 17.625H21.7506M2.25 19.125V4.5M3.81055 12.375H21.7506M3.81055 13.875H21.7506M21.75 19.125V7.875" stroke="#333" stroke-linecap="round"/><path d="M9.27112 12.375C9.27112 11.5466 8.39805 10.5 7.32109 10.5C6.24414 10.5 5.37109 11.5466 5.37109 12.375" stroke="#333"/></svg>
</template>
<script>

export default {
  name: 'IconSuShe',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
